
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientwarminfdevice() {



  const cardData =
  {
    keyword: 'Patient Warming Devices',
    heading: 'Pharmacle Health Care Private Limited: Patient Warming Devices',
    headingDescription: 'Pharmacle Health Care Private Limited offers high-quality Patient Warming Devices in Kolkata, designed to ensure optimal temperature regulation during surgeries and critical medical procedures. Our innovative devices help prevent perioperative hypothermia by delivering consistent, controlled warmth, significantly enhancing patient comfort and recovery. Trusted by hospitals and healthcare providers, our warming devices are reliable, user-friendly, and built with advanced technology. Choose Pharmacle Health Care for the most effective patient warming solutions in Kolkata to support better clinical outcomes and patient care.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "Advanced Patient Warming Devices for Effective Thermal Care",
    "description": "Pharmacle Health Care offers state-of-the-art patient warming devices designed to maintain optimal body temperature during surgeries and recovery. These devices ensure enhanced patient comfort and clinical safety."
  },
  {
    "title": "Best Patient Warming Devices for Hospitals and Critical Units",
    "description": "Our medical-grade warming devices are engineered for ICU, operating rooms, and emergency care. They help reduce the risk of hypothermia and promote better healing outcomes for all patient types."
  },
  {
    "title": "Reliable Patient Warming Devices for Safe Medical Treatment",
    "description": "Pharmacle Health Care provides dependable warming devices that deliver consistent temperature regulation. Ideal for healthcare facilities aiming to improve patient safety and treatment efficiency."
  },
  {
    "title": "High-Performance Patient Warming Devices for Medical Applications",
    "description": "Designed for use across various departments including surgical suites and recovery rooms, our warming devices ensure precise temperature management and contribute to optimal patient outcomes."
  },
  {
    "title": "Buy Patient Warming Devices for Clinical Efficiency",
    "description": "Choose Pharmacle Health Care’s warming devices to enhance your medical setup. Perfect for neonatal units, trauma care, and post-operative recovery, offering effective heat distribution and ease of use."
  },
  {
    "title": "Cutting-Edge Patient Warming Devices for Thermal Stability",
    "description": "Pharmacle Health Care’s warming devices are built with advanced technology to stabilize core body temperatures in patients, reducing the chances of surgical and recovery complications."
  },
  {
    "title": "Affordable and Efficient Patient Warming Devices",
    "description": "Get cost-effective solutions without compromising on quality. Our patient warming devices offer reliable thermal control that meets the needs of modern healthcare environments."
  },
  {
    "title": "Trusted Supplier of Patient Warming Devices",
    "description": "Hospitals and clinics trust Pharmacle Health Care for high-quality patient warming devices. Designed for easy integration into existing systems and backed by technical expertise."
  },
  {
    "title": "Patient Warming Devices for Pediatric and Adult Use",
    "description": "Our devices are suitable for all age groups and provide gentle, controlled warmth. Pharmacle Health Care ensures superior patient care across diverse clinical settings."
  },
  {
    "title": "Medical-Grade Patient Warming Devices for Superior Care",
    "description": "Enhance patient care with our certified warming devices that support efficient temperature control during critical and routine medical procedures."
  }
],

     "services": [
    {
      "name": "Patient Warming Devices",
      "description": "Pharmacle Health Care offers patient warming devices designed to maintain a stable body temperature during various medical procedures. These devices are essential in preventing hypothermia and enhancing patient safety and comfort."
    },
    {
      "name": "Medical Warming Equipment",
      "description": "Our medical warming equipment is crafted to support effective temperature control in clinical environments. These systems help regulate patient temperature during and after medical procedures, improving outcomes and safety."
    },
    {
      "name": "Hospital Patient Heating Devices",
      "description": "We provide hospital-grade patient heating devices to ensure consistent thermoregulation across surgical and recovery settings. These devices are crucial for minimizing temperature-related risks in hospital care."
    },
    {
      "name": "Perioperative Warming Machines",
      "description": "Pharmacle Health Care supplies perioperative warming machines that function throughout the surgical cycle—from pre-op to post-op. These machines enhance patient care by maintaining body temperature during critical phases."
    },
    {
      "name": "Surgical Temperature Management Devices",
      "description": "Our surgical temperature management devices are built to maintain normothermia during operations. These systems help reduce perioperative complications and support optimal surgical outcomes."
    },
    {
      "name": "Intraoperative Heat Therapy Units",
      "description": "We offer intraoperative heat therapy units designed to deliver consistent thermal support during surgery. These units are vital for stabilizing core temperature and preventing intraoperative hypothermia."
    },
    {
      "name": "Patient Heat Maintenance Systems",
      "description": "Pharmacle Health Care provides patient heat maintenance systems to support ongoing temperature regulation throughout treatment. These systems contribute to improved recovery and reduced complications."
    }
  ],
  "tableData": [
    ["- Patient Warming Devices", "- Medical Warming Equipment"],
    ["- Hospital Patient Heating Devices", "- Perioperative Warming Machines"],
    ["- Surgical Temperature Management Devices", "- Intraoperative Heat Therapy Units"],
    ["- Patient Heat Maintenance Systems"]
  ],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced Patient Warming Devices in Kolkata, designed to deliver precise temperature control during medical treatments. Our technology ensures dependable performance to prevent hypothermia, enhancing patient safety in hospitals and clinics across the region."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a diverse range of Patient Warming Devices in Kolkata, including heating units, warming blankets, and control systems. Our solutions support surgical and critical care procedures, helping patients stay safe and comfortable throughout their recovery."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our Patient Warming Devices are built to the highest quality standards, ensuring long-lasting durability and performance. Each device undergoes rigorous testing and maintenance, offering reliable functionality in demanding medical environments across Kolkata."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our foremost concerns. Our Patient Warming Devices provide gentle, controlled warmth to prevent temperature-related complications during medical procedures, ensuring a safe and soothing experience for patients in Kolkata."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our Patient Warming Devices are designed to suit a variety of healthcare settings in Kolkata, from hospitals and clinics to emergency rooms. We customize our solutions to meet the unique needs of each provider, supporting optimal patient care and operational efficiency."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s Patient Warming Devices are engineered for seamless integration with existing medical equipment in Kolkata. Our systems are easy to implement, ensuring minimal disruption and maximum compatibility with current workflows."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We offer expert consultation services in Kolkata to help healthcare facilities choose the most suitable Patient Warming Devices. Our support team is available for ongoing assistance and maintenance, ensuring your equipment performs reliably at all times."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, our Patient Warming Devices are designed with a strong focus on patient safety and comfort. We strive to prevent temperature-related issues during vital procedures, delivering the highest standard of care to patients throughout Kolkata."
    }
]























  }

const faqData = [
  {
    question: "What are Patient Warming Devices?",
    answer: "Patient Warming Devices are medical tools designed to maintain or raise a patient’s body temperature during surgeries or treatments. They help prevent hypothermia by delivering controlled heat through blankets, pads, or other warming components."
  },
  {
    question: "Why are Patient Warming Devices important?",
    answer: "These devices are critical in preventing perioperative hypothermia, reducing the risk of surgical complications, enhancing patient comfort, and promoting quicker recovery after medical procedures."
  },
  {
    question: "Are Patient Warming Devices available in Kolkata?",
    answer: "Yes, Pharmacle Health Care Private Limited supplies high-quality Patient Warming Devices to healthcare institutions throughout Kolkata, helping ensure safe and effective temperature management during procedures."
  },
  {
    question: "What types of Patient Warming Devices are offered by Pharmacle Health Care?",
    answer: "Pharmacle Health Care offers a range of Patient Warming Devices, including forced air warming systems and warming blankets, tailored to meet the needs of various medical environments."
  },
  {
    question: "Can Patient Warming Devices be used for all patient types?",
    answer: "Yes, when used correctly under professional supervision, these devices are generally safe for most patients, including pediatric, adult, and elderly individuals undergoing surgery or extended treatments."
  },
  {
    question: "How can I purchase Patient Warming Devices from Pharmacle Health Care?",
    answer: "You can contact Pharmacle Health Care Private Limited directly. Our team will assist with product selection, purchasing, and delivery to your healthcare facility in Kolkata."
  }
];

const testimonialsData = [
  {
    text: "Pharmacle Health Care’s Patient Warming Devices have made a real difference in our surgical outcomes. Patients stay warm, safe, and comfortable, and we’ve seen fewer postoperative complications.",
    name: "Dr. Priya Mitra"
  },
  {
    text: "We've been consistently impressed with the quality and reliability of the Patient Warming Devices supplied by Pharmacle Health Care. Their team also provides excellent support and training.",
    name: "City Medical Center, Kolkata"
  }
];


  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



 
  
const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Patient Warming Devices",
  "description": "Explore advanced Patient Warming Devices designed for effective temperature control and heat therapy during surgical and perioperative care. Ensure patient safety and comfort with our reliable medical warming equipment.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5154"
  }
};



  return (
    <div>
  
<Helmet>
  <title>Patient Warming Devices | Contact: +91 8956322311</title>
  <meta
    name="description"
    content="Explore Patient Warming Devices for effective temperature control and perioperative heat therapy. Contact us at +91 8956322311."
  />
  <meta
    name="keywords"
    content="Patient Warming Devices, Medical Warming Equipment, Hospital Patient Heating Devices, Perioperative Warming Machines, Surgical Temperature Management Devices, Intraoperative Heat Therapy Units, Patient Heat Maintenance Systems"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

  

      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/60.png' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Navar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientwarminfdevice;